module.exports = __webpack_public_path__ + "static/media/YM15_0.13ea53a8.jpg";